import React from 'react';
import { Link } from 'react-router-dom';

export const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      
    {/* About Us & Vision Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">About Us</h2>
              <div className="space-y-6 text-gray-700 leading-relaxed">
                <p className="text-lg">
                  Welcome to Aaran Homes, where your journey to finding the perfect home begins.
                </p>
                <p>
                  As a premier real estate company dedicated to transforming dreams into reality, we take immense pride in our commitment to excellence, innovation, and personalized service.
                </p>
                <p>
                  At Aaran Homes, we understand that purchasing a home is not just about acquiring a property - it's about finding a sanctuary where memories are made and futures are shaped.
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="aspect-square bg-gradient-to-br from-primary/20 to-tertiary/20 rounded-3xl overflow-hidden">
                <img
                  src= "\maria-krasnova-qD7tpy_VozY-unsplash.jpg"
                  alt="Girl image of second home"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
              <p className="text-gray-700 leading-relaxed">
                Our mission is clear: to deliver quality services, particularly in the realm of industrial development, through our team of expert professionals.
              </p>
            </div>
            <div className="bg-gradient-to-br from-tertiary/5 to-tertiary/10 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
              <p className="text-gray-700 leading-relaxed">
                At our core, our vision is driven by a commitment to excellence and client satisfaction. With a clear mission to deliver top-quality services, our dedicated team of expert professionals stands ready to turn vision into reality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision for the Future Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Vision for the Future
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Building sustainable communities that harmonize modern living with nature's tranquility
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-xl">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-tertiary rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl text-white">🌟</span>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Shaping Tomorrow's Living</h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-8">
                  Our vision extends beyond just providing properties. We envision creating self-sustaining communities where technology meets tradition, where urban comfort blends with rural serenity, and where every investment contributes to a greener, more prosperous future.
                </p>
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                      <span className="text-xl">🌱</span>
                    </div>
                    <h4 className="font-semibold text-gray-900 mb-2">Sustainable Growth</h4>
                    <p className="text-sm text-gray-600">Eco-friendly development practices</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center mx-auto mb-4">
                      <span className="text-xl">🤝</span>
                    </div>
                    <h4 className="font-semibold text-gray-900 mb-2">Community Building</h4>
                    <p className="text-sm text-gray-600">Fostering connections and relationships</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 bg-tertiary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                      <span className="text-xl">🎯</span>
                    </div>
                    <h4 className="font-semibold text-gray-900 mb-2">Innovation</h4>
                    <p className="text-sm text-gray-600">Cutting-edge agricultural technology</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Leadership Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Leadership Excellence
            </h2>
            <p className="text-xl text-gray-600">
              Meet our visionary leader driving innovation in real estate
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-primary/5 to-tertiary/5 rounded-3xl p-8 lg:p-12">
              <div className="text-center mb-8">
                <div className="w-32 h-32 mx-auto mb-6 bg-gradient-to-br from-primary to-tertiary rounded-full flex items-center justify-center">
                  <span className="text-3xl font-bold text-white">MM</span>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Mehul Marolia</h3>
                <p className="text-lg text-primary font-semibold mb-4">Chief Executive Officer</p>
                <div className="text-sm text-gray-600 font-medium mb-6">reEvolution Leadership</div>
              </div>
              
              <div className="prose prose-lg mx-auto text-gray-700 leading-relaxed">
                <p className="mb-6">
                  As the CEO of AaranHomes, I am delighted to extend a warm greeting to each of you. At AaranHomes, we are passionate about connecting individuals and families with their dream farmhouses, while also revolutionizing the agricultural landscape with innovative polyhouse solutions.
                </p>
                <p className="mb-6">
                  Our journey began with a simple yet profound mission – to bridge the gap between urban living and rural tranquility by offering premium farmhouse properties nestled amidst nature's bounty. Whether you're seeking a weekend retreat, a retirement haven, or an investment opportunity, we have the perfect farmhouse waiting for you.
                </p>
                <p className="mb-6">
                  But our commitment doesn't stop there. We understand the importance of sustainable agriculture in today's world, which is why we've partnered with leading experts to introduce cutting-edge polyhouse concepts. These state-of-the-art structures not only maximize crop yields but also minimize environmental impact, ensuring a greener, more sustainable future for generations to come.
                </p>
                <p>
                  At AaranHomes, we pride ourselves on delivering unparalleled service and expertise to our customers. From personalized property recommendations to tailored marketing strategies, our dedicated team is here to guide you every step of the way. As we continue to grow and evolve, our focus remains firmly on our customers and their needs. Whether you're a homeowner looking to purchase your farmhouse or finding a second home, we are here to turn your vision into reality.
                </p>
              </div>
              
              <div className="flex justify-center space-x-6 mt-8">
                <a href="#" className="text-primary hover:text-primary/80 transition-colors">
                  <span className="sr-only">WhatsApp</span>
                  📱
                </a>
                <a href="#" className="text-primary hover:text-primary/80 transition-colors">
                  <span className="sr-only">LinkedIn</span>
                  💼
                </a>
                <a href="#" className="text-primary hover:text-primary/80 transition-colors">
                  <span className="sr-only">Medium</span>
                  📖
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Model Section */}
      <section className="py-20 bg-gradient-to-br from-primary/10 to-tertiary/10">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Our Business Model
            </h2>
            <h3 className="text-2xl font-semibold text-primary mb-6">
              INVEST, ENJOY AND EARN
            </h3>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="text-center">
                <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl text-white">💰</span>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">INVEST</h4>
                <p className="text-gray-600">Invest in farmhouse plots and secure your future with tangible assets</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl text-primary">🌱</span>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">EARN</h4>
                <p className="text-gray-600">Generate sustainable returns through innovative polyhouse concepts</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-tertiary rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl text-white">🏡</span>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">ENJOY</h4>
                <p className="text-gray-600">Experience nature's beauty in your own farmhouse sanctuary</p>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-xl">
              <p className="text-lg text-gray-700 leading-relaxed text-center">
                At AaranHomes, we offer a unique and rewarding business model that encompasses three key elements: Invest, Earn, and Enjoy. Our model begins with the opportunity to invest in farmhouse plots, providing individuals with a tangible asset in the serene countryside. Through innovative polyhouse concepts, our clients can earn sustainable returns from their investment, harnessing modern agricultural technology to cultivate crops year-round. Additionally, our farmhouses are designed to provide a sanctuary where one can enjoy nature's beauty and amenities, offering a perfect blend of relaxation and recreation.
              </p>
            </div>
          </div>
        </div>
      </section>

      

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-r from-primary to-tertiary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Ready to Be Part of Our Story?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
            Join hundreds of satisfied families who have found their dream farmhouses with AARAN HOMES
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-secondary text-primary px-8 py-4 rounded-lg font-semibold hover:bg-secondary/90 transition-colors duration-200"
            >
              Start Your Journey
            </Link>
            <Link
              to="/properties"
              className="bg-white/10 text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors duration-200 border border-white/20"
            >
              View Properties
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};